<script setup lang="ts">
const { environment } = useRuntimeConfig().public
const localePath = useLocalePath()
const { appBarLogoRed, registrationPageLogo } = useCountryConfig()

const logoSrc = computed(() => appBarLogoRed ?? registrationPageLogo)
</script>

<template>
  <NuxtLink
    :to="localePath('/')"
    data-nav-id="header_logo"
    class="d-flex align-center ga-3 py-1"
  >
    <NuxtImg
      src="/images/bird.svg"
      width="30"
      height="38"
      alt=""
    />
    <v-badge
      v-if="environment !== 'prod'"
      :content="environment"
      :color="environment === 'staging' ? 'heiland-light-blue' : 'heiland-purple'"
    >
      <nuxt-picture
        :src="logoSrc"
        width="128"
        height="30"
        alt="Logo"
      />
    </v-badge>
    <nuxt-picture
      v-else
      :src="logoSrc"
      width="128"
      height="30"
      alt="Logo"
    />
  </NuxtLink>
</template>
